// 菜单，侧边栏
import dashboard from './modules/dashboard';

// 系统
import log from './modules/log';

export default [
    dashboard,
    log
];
